import React, { useState } from 'react';
import { 
  AppBar, 
  Toolbar, 
  Typography, 
  Button, 
  styled,
  IconButton,
  Box,
  useTheme,
  useMediaQuery,
  Tabs,
  Tab,
  Tooltip
} from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MenuIcon from '@mui/icons-material/Menu';
import ViewSidebarIcon from '@mui/icons-material/ViewSidebar';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import EventIcon from '@mui/icons-material/Event';
import UserProfile from '../auth/UserProfile';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { useNavigate, useLocation } from 'react-router-dom';
const StyledAppBar = styled(AppBar)`
  background-color: #1a1a1a;
`;

interface HeaderProps {
  onMenuClick: () => void;
  onSidebarClick: () => void;
  showMenuButton: boolean;
}

const Header: React.FC<HeaderProps> = ({ onMenuClick, onSidebarClick, showMenuButton }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();
  // const [calendarModalOpen, setCalendarModalOpen] = useState(false);
  
  // We no longer need tabs in the header
  const getActiveTab = () => {
    return 0; // Dashboard is default
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    if (newValue === 0) {
      navigate('/');
    }
  };

  return (
    <>
      <StyledAppBar position="static">
        <Toolbar sx={{ gap: 1 }}>
          {showMenuButton && (
            <IconButton
              color="inherit"
              edge="start"
              onClick={onMenuClick}
              size="large"
            >
              <MenuIcon />
            </IconButton>
          )}

          <Typography 
            variant={isMobile ? "body1" : "h6"} 
            component="div" 
            sx={{ 
              flexGrow: 1,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}
          >
            ONO Operator
          </Typography>

          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            {isAuthenticated ? (
              <UserProfile />
            ) : (
              <>
                <Button 
                  color="inherit" 
                  startIcon={<AccountCircleIcon />}
                  sx={{ 
                    display: { xs: 'none', sm: 'flex' }
                  }}
                >
                  Login
                </Button>
                <IconButton 
                  color="inherit"
                  sx={{ 
                    display: { xs: 'flex', sm: 'none' }
                  }}
                >
                  <AccountCircleIcon />
                </IconButton>
              </>
            )}

            {showMenuButton && (
              <IconButton
                color="inherit"
                edge="end"
                onClick={onSidebarClick}
                size="large"
              >
                <ViewSidebarIcon />
              </IconButton>
            )}
          </Box>
        </Toolbar>
      </StyledAppBar>
    </>
  );
};

export default Header;
